import React from 'react';
import AppBar from '@mui/material/AppBar';
import Typography from '@mui/material/Typography';
import { drawerWidth } from '../../../constants';
import { SxStyle } from '../../../types';

const styles: SxStyle = {
  container: (theme) => ({
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidth}px)`,
    },
    backgroundColor: theme.palette.menu.light,
    boxShadow: 'none',
    borderTopStyle: 'solid',
    borderTopWidth: '1px',
    borderTopColor: 'rgb(0, 0, 0, 12%)',
    top: 'auto',
    bottom: 0,
    height: '56px',
    justifyContent: 'center',
    alignItems: 'flex-end',
    display: 'flex',
    paddingLeft: '10px',
    paddingRight: '10px',
    color: '#fff',
  }),
  textFirst: (theme) => ({
    [theme.breakpoints.down('md')]: {
      fontSize: '12px',
    },
    fontSize: '15px',
    '& a': {
      color: '#fff',
      '&:hover': {
        textDecoration: 'none',
      },
    },
  }),
  textSecond: (theme) => ({
    [theme.breakpoints.down('md')]: {
      fontSize: '10px',
    },
    fontSize: '13px',
    '& a': {
      color: '#fff',
      '&:hover': {
        textDecoration: 'none',
      },
    },
  }),
};

function SceneBottomBar() {
  return (
    <AppBar position="fixed" sx={styles.container} color="transparent">
      <Typography variant="body2" sx={styles.textFirst}>
        Superadmin samt liga- och klubbappar levereras av Svensk Elitfotboll -&nbsp;
        <Typography variant="body2" sx={styles.textSecond} component="span">
          Frågor, feedback och förslag mottages i Slack-kanalen{' '}
          <a
            href="https://connectedleague.slack.com/channels/livekanalen"
            target="_blank"
            rel="noreferrer"
          >
            #Livekanalen
          </a>
        </Typography>
      </Typography>
    </AppBar>
  );
}

export default SceneBottomBar;
